import Factory from './utils/factory'

export default Factory({
  id: null,
  status: 'undone',
  title: null,
  description: null,
  dueAt: null,
  members: [],
  images: [],
  attachments: [],
  reference: null,
  tags: [],
})
